<template>
  <b-sidebar
    id="site-types-form-sidebar"
    :visible="isSiteTypesFormSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="getData(siteTypesData)"
    @hidden="resetForm"
    @change="(val) => $emit('update:is-site-types-form-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0"> Site Type Form </h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="name"
            rules="required"
          >
            <b-form-group label="Type Name" label-for="name">
              <b-form-input
                id="name"
                v-model="Data.name"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder="type name"
                @input="autoInputSlug"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <!-- <validation-provider
            #default="validationContext"
            name="slug"
            rules="required"
          >
            <b-form-group
              label="Slug"
              label-for="slug"
            >
              <b-form-input
                  id="slug"
                  v-model="Data.slug"
                  autofocus
                  :state="getValidationState(validationContext)"
                  trim
                  placeholder="Slug"
              />
              <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider> -->
          <validation-provider
            #default="validationContext"
            name="IsActive"
            rules="required"
          >
            <b-form-group label="Is Active" label-for="IsActive">
              <b-form-checkbox
                id="isactive"
                checked="true"
                class="custom-control-success"
                v-model="Data.is_active"
                switch
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-success"
              class="mr-2"
              type="submit"
            >
              Save
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-danger"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
  import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormCheckbox, BFormInvalidFeedback, BButton,BTabs,BTab
  } from 'bootstrap-vue'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import { ref,onUnmounted } from '@vue/composition-api'
  import Ripple from 'vue-ripple-directive'
  import formValidation from '@core/comp-functions/forms/form-validation'
  import store from '@/store'
  import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
  import { useToast } from 'vue-toastification/composition'
  import { required, alphaNum, email, password, confirmed } from "@validations";
  import { slugify } from '@/@fake-db/utils'

  export default {

    components: {
      BSidebar,
      BForm,
      BFormGroup,
      BFormInput,
      BFormCheckbox,
      BFormInvalidFeedback,
      BButton,
      BTabs,BTab,
      ValidationProvider,
      ValidationObserver
    },

    directives: {
      Ripple,
    },

    model: {
      prop: 'isSiteTypesFormSidebarActive',
      event: 'update:is-site-types-form-sidebar-active',
    },

    props: {
      isSiteTypesFormSidebarActive: {
        type: Boolean,
        required: true,
      },
      
      siteTypesData: {
        type: Object,
        required: false,
      },
    },

    setup(props, { emit }) {
      const toast = useToast()
      const userStorage = JSON.parse(localStorage.getItem('userData'));

      const blankData = {
        name: "",
        is_active: true,
        created_by: userStorage.id,
      }

      const Data = ref(blankData)
      const tabIndex = ref(0);

      const resetData = () => {
          Data.value = blankData;
      }

      const autoInputSlug = () => {
        Data.value.slug =  slugify(Data.value.name)
      }

      const getData = (data)=>{
        tabIndex.value = 0;

        if(data){
          data.is_active = data.is_active?true:false;
          return Data.value  = data;
        }
        
        Data.value = blankData
      }

      const onSubmit = () => {
        Data.value.is_active = Data.value.is_active?1:0;

        if(Data.value.id) {
          store.dispatch("app-sites/updateSiteType", Data.value)
            .then((res) => {
              toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Success`,
                  icon: "BellIcon",
                  variant: "success",
                  text: `${res.data.message}`,
                }
              });
              emit("refetch-data");
              emit("update:is-site-types-form-sidebar-active", false);
            }).catch((error) => {
              toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Error`,
                  icon: "BellIcon",
                  variant: "danger",
                  text: error.response.data.message,
                },
              });
            }
          );
        } else {
          Data.value.created_by = userStorage.id

          store.dispatch("app-sites/addSiteType", Data.value)
            .then((res) => {
              toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Success`,
                  icon: "BellIcon",
                  variant: "success",
                  text: `${res.data.message}`,
                },
              });

              emit("refetch-data");
              emit("update:is-site-types-form-sidebar-active", false);
            }).catch((error) => {
              toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: `Error`,
                  icon: "BellIcon",
                  variant: "danger",
                  text: error.response.data.message,
                },
              });
            }
          );
        }
      }

      const {
        refFormObserver,
        getValidationState,
        resetForm,
      } = formValidation(resetData)

      return {
        refFormObserver,
        getValidationState,
        resetForm,
        resetData,
        getData,
        tabIndex,
        Data,
        onSubmit,
        autoInputSlug,
      }
    }
  }
</script>